import _ from "lodash";
import { InputSelector } from "../../components/Forms/InputSelector";
import { IBaseFormProps } from "../../components/interfaces";
import {
  IUploadLocations,
  MediaInput,
} from "../../components/Forms/FileHandling/MediaInput";
import { checkFieldName } from "../../utils";

/**
 *
 * @param schema loaded schema
 * @param modelName name of model
 * @param itemData itemData state
 * @param setItemData setItemData state
 * @returns
 */

const baseFields = ["caption", "imageUrl"];

const WorkPhotosForm = ({
  schema,
  modelName,
  itemData,
  setItemData,
  customModel,
  onSubmit,
}: IBaseFormProps): JSX.Element => {
  const updateItemData = (keyname: string, value: any) => {
    if (_.has(itemData, keyname))
      setItemData({
        ...itemData,
        [keyname]: value,
      });
  };

  const updateMedia = (
    keyname: string,
    location: string,
    thumbLocation: string
  ) => {
    if (_.has(itemData, "thumbnail") && _.has(itemData, keyname)) {
      const newData = {
        ...itemData,
        [keyname]: location,
        thumbnail: thumbLocation, //<-- add CMS thumb field here
      };
      setItemData(newData);
    }
  };

  const filteredSchema = schema.filter((field) =>
    _.includes(baseFields, field.name)
  );

  return (
    <form onSubmit={onSubmit} id="base-form">
      <div className="flex flex-col gap-4">
        {filteredSchema.map((item, index) => {
          const isMedia = item.type === "image" || item.type == "video";

          if (!isMedia)
            return (
              <InputSelector
                value={itemData[item.name]}
                key={index}
                onChange={(e) => {
                  updateItemData(
                    item.name,
                    item.type === "number"
                      ? e.target.valueAsNumber
                      : item.type === "bool"
                      ? e.target.checked
                      : e.target.value
                  );
                }}
                modelname={modelName}
                customModel={customModel}
                {...item}
              />
            );
          const [displayName, hint, required] = checkFieldName(
            item.name,
            modelName
          );

          return (
            <MediaInput
              key={index}
              type={item.type}
              name={displayName}
              value={itemData[item.name]}
              thumbUrl={itemData.thumbnail}
              onChange={(e: IUploadLocations) => {
                updateMedia(
                  item.name,
                  e.fileLocation || "",
                  e.thumbLocation || ""
                );
              }}
              required={required}
              hint={hint}
            />
          );
        })}
      </div>
    </form>
  );
};

export default WorkPhotosForm;
